import { PortalModal } from '@provi/provi-components'
import styled from 'styled-components'
import Spinner from '../../../cancellation/TypeOfPayment/dataBank/Spinner'

export const StyledModal = styled(PortalModal)`
  width: 600px;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const ModalWrapper = styled.div`
  max-height: auto;
  max-width: 100%;
  padding: 32px;
  border: none;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 600px) {
    padding: 16px;
  }
`

export const HeaderWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const Description = styled.p`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  overflow-wrap: break-word;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`

export const Row = styled.p`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  overflow-wrap: break-word;

  strong {
    margin-right: 4px;
  }

  @media (max-width: 600px) {
    font-size: 14px;
  }
`

export const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px; /* [FIX] ponto e vírgula */

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const CancelButton = styled.button`
  padding: 8px 24px;
  height: 40px;
  min-width: 120px;
  width: 180px;
  border-radius: 6px;
  border: 1px solid #006eab;
  background-color: #f1f1f1;
  color: #006eab;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const ConfirmButton = styled.button`
  padding: 8px 24px;
  height: 40px;
  min-width: 120px;
  width: 180px;
  border-radius: 6px;
  background-color: #006eab;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  border: none;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 100%;
  }
`
export const SpinnerCenter = styled.span`
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`

export const SmallSpinner = styled(Spinner)`
  width: 20px;
  height: 20px;
  border-width: 3px;
  margin: 0;
  display: block; /* evita baseline estranho */
`
